import React, { useState } from 'react';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        address: '',
        description: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Format form data for WhatsApp message
        const message = `New Contact Form Submission:%0AName: ${encodeURIComponent(formData.name)}%0AEmail: ${encodeURIComponent(formData.email)}%0AContact: ${encodeURIComponent(formData.contact)}%0AAddress: ${encodeURIComponent(formData.address)}%0ADescription: ${encodeURIComponent(formData.description)}`;
        const whatsappUrl = `https://wa.me/+919140111654?text=${message}`;
        
        // Redirect to WhatsApp
        window.open(whatsappUrl, '_blank');

        // Reset form
        setFormData({
            name: '',
            email: '',
            contact: '',
            address: '',
            description: ''
        });
    };

    return (
        <div className="min-vh-100 bg-light d-flex flex-column">
           
           <div className='headings'>
                <h3>contact</h3>
            </div>

            <main className="flex-grow-1 container my-5">
                <div className="row g-4">
                    {/* Contact Form */}
                    <div className="col-lg-6">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h4 className="card-title mb-4 fw-bold">Get in Touch</h4>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Your Name"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="contact" className="form-label">Contact Number</label>
                                        <input
                                            type="tel"
                                            id="contact"
                                            name="contact"
                                            value={formData.contact}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="contact"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            id="address"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Your Address"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                            rows="4"
                                            className="form-control"
                                            placeholder="Your message or inquiry"
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                    >
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Google Map */}
                    <div className="col-lg-6">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h4 className="card-title mb-4 fw-bold">Our Location</h4>
                                <div className="ratio ratio-4x3">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d56959.15556475196!2d80.9265851!3d26.8416309!3m2!1i1024!2i768!4f13.1!2m1!1sas%20traders%20lucknow!5e0!3m2!1sen!2sin!4v1747375543684!5m2!1sen!2sin"
                                        className="rounded"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="AS Traders Location"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Contact;